import type { Listing } from '@thevillages/schemas';

import { Component, computed, input } from '@angular/core';

import { ListingDetailsAccordion } from '../accordion/accordion';

@Component({
  imports: [ListingDetailsAccordion],
  selector: 'app-listing-details-features-details',
  templateUrl: './features-details.html',
})
export class ListingDetailsFeaturesDetails {
  public readonly listing = input.required<Listing>();

  public readonly remainingFeatures = computed(() => this.listing().features?.slice(5) ?? []);
  public readonly topFeatures = computed(() => this.listing().features?.slice(0, 5) ?? []);
}
